import React, { useState, useEffect, useContext, Fragment, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Slider from "react-slick";
import WinningMetrics from "../../../../../components/WinningMetrics";
import { AppContext } from "../../../../../context/state";
import { useCookies } from "react-cookie";
import { getDefYear, getYearArray } from "../../../../../constants/main";
import { TableHeader } from "../../../../../nextJSComponents/TableHeader";
import List from "../../../../../components/list/List";
import TableCellRank from "../../../../../components/table/TableCellRank";
import TableCellAdjSQ from "../../../../../components/table/TableCellAdjSQ";
import LoadingSkeleton from "../../../../../components/animations/LoadingSkeleton";
import TableSkeleton from "../../../../../components/table/TableSkeleton";
import SQDocCard from "../../../../../components/card/SQDocCard";
import TeamRegressionAnalysis from "../../../../../components/table-templates/TeamRegressionAnalysis";
import TeamShotTypeAnalysis from "../../../../../components/table-templates/TeamShotTypeAnalysis";
import TeamMiscAnalysis from "../../../../../components/table-templates/TeamMiscAnalysis";
import TeamContestData from "../../../../../components/table-templates/TeamContestData";
import Link from "next/link";
import { useRouter } from "next/router";
import {
  playerStatsHeader2020,
  playerStatsHeader2021,
  teamSummaryHeader2020,
  teamSummaryHeader2021,
  allPlaysHeaderList,
  shotTypeAnalysisCategories,
  scheduleRecordHeader,
  sqDocSliderSettings,
} from "../../../../../constants/main";
import Utils from "../../../../../utils/Utils";
import { authGetRequest } from "../../../../../utils/authGetRequest";
import Head from "next/head";
import { TiDevicePhone } from "react-icons/ti";
import MainLayout from "../../../../../components/MainLayout/MainLayout";
import Lock from "../../../../../components/Lock";
import { SIGNUPS_CLOSED_MESSAGE } from "../../../../../constants/main";
dayjs.extend(customParseFormat);

const CustomLock = () => {
  return (
    <th style={{ backgroundColor: "transparent", borderTop: "0px", display: "flex", justifyContent: "center" }}>
      <div className="d-flex align-items-center justify-content-center">
        <span>{Lock}</span>
      </div>
      <div className="tooltipCon" style={{ zIndex: "99" }}>
        <b className="d-block mb-0">Get Full List of SQ Scores</b>
        <h6>
          For a full list of SQ Scores, please{" "}
          <a className="d-inline" href="mailto:hello@shotquality.com">
            contact us
          </a>
          .
        </h6>
      </div>
    </th>
  );
};

const Team = () => {
  const router = useRouter();
  const team_name = router.query?.teamName;
  const { league } = router.query;
  const { store, setStore } = useContext(AppContext);
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const [authToken, setAuthToken] = useState();
  const [user, setUser] = useState(null);
  const [coachTeam, setCoachTeam] = useState("");

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
    setCoachTeam(localStorage.getItem("school"));
    document.cookie.includes("token_access=") &&
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
  }, []);

  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isTraderPlan = Utils.isTrader(user);

  let leagueName = league;
  let leagueType = league === "ncaa" ? "college_mens" : league === "ncaaw" ? "college_womens" : league;

  const sliderRef = useRef();
  const [availableYearData, setAvailableYearData] = useState([]);
  const [playersStat, setPlayersStat] = useState([]);
  const [allPlays, setAllPlays] = useState([]);
  const [filteredAllPlays, setFilteredAllPlays] = useState([]);

  const [ascOrderPlayersStat, setAscPlayersStat] = useState(false);
  const [sortedKeyPlayersStat, setSortedKeyPlayersStat] = useState("");
  const [year, setYear] = useState(router.query.year || getDefYear(leagueType));
  const defaultYear = getDefYear(leagueType);
  const yearArray = getYearArray(leagueType);
  const [ascOrderAllPlays, setAscAllPlays] = useState(false);
  const [sortedKeyAllPlays, setSortedKeyAllPlays] = useState("");

  const [teamRank, setTeamRank] = useState();
  const [teamDescriptions, setTeamDescriptions] = useState([]);
  const [teamDescriptionRecordLength, setTeamDescriptionRecordLength] = useState(0);
  const [teamSummary, setTeamSummary] = useState([]);

  const [teamSummaryHeader, setTeamSummaryHeader] = useState(teamSummaryHeader2021);
  const [coachRecord, setCoachRecord] = useState({});

  const [teamRecord, setTeamRecord] = useState([]);
  const [scheduleRecord, setScheduleRecord] = useState([]);

  const [scheduleRecordLoaded, setScheduleRecordLoaded] = useState(false);
  const [ascOrderSchedule, setAscSchedule] = useState(false);
  const [sortedKeySchedule, setSortedKeySchedule] = useState("");

  const [teamName, setTeamName] = useState("");
  const [allPlaysOccurrencesMinMax, setAllPlaysOccurrencesMinMax] = useState([0, 50]);
  const [allPlaysOccurrencesDefault, setAllPlaysOccurrencesDefault] = useState(0);

  const [playerStatsHeader, setPlayerStatsHeader] = useState(playerStatsHeader2021);
  const [allPlaysHeader, setAllPlaysHeader] = useState(allPlaysHeaderList);
  const [loadMoreSchedule, setLoadMoreSchedule] = useState(false);
  const [playerPlaytypes, setPlayerPlaytypes] = useState([]);

  const [confPlayTypes, setConfPlaytypes] = useState([]);
  const [teamPlayTypesOFF, setTeamPlayTypesOFF] = useState([]);
  const [teamPlayTypesDEF, setTeamPlayTypesDEF] = useState([]);
  const [confPlayTypesOFF, setConfPlayTypesOFF] = useState([]);
  const [confPlayTypesDEF, setConfPlayTypesDEF] = useState([]);
  const [sortedShotTypes, setSortedShotTypes] = useState({
    player: {},
    conf: {},
  });
  const [regressionOFF, setRegressionOFF] = useState({});
  const [regressionDEF, setRegressionDEF] = useState({});
  const [regressionEFF, setRegressionEFF] = useState({});
  const [confRegressionOFF, setConfRegressionOFF] = useState({});
  const [confRegressionDEF, setConfRegressionDEF] = useState({});
  const [miscOFF, setMiscOFF] = useState({});
  const [miscDEF, setMiscDEF] = useState({});
  const [confMiscOFF, setConfMiscOFF] = useState({});

  const [confMiscDEF, setConfMiscDEF] = useState({});
  const [miscLoaded, setMiscLoaded] = useState(false);
  const [regressionLoaded, setRegressionLoaded] = useState(false);
  const [shotTypeLoaded, setShotTypeLoaded] = useState(false);
  const [allTablesLoaded, setAllTablesLoaded] = useState(false);
  const [conferenceTeamCount, setConferenceTeamCount] = useState(0);
  const [teamOptimizationSenteces, setTeamOptimizationSentences] = useState([]);
  const [teamPlayers, setTeamPlayers] = useState([]);
  const [mappedPredictions, setMappedPredictions] = useState([]);
  const [scheduleFilter, setScheduleFilter] = useState("All");
  const [teamPredictions, setTeamPredictions] = useState(null);
  const [teamContestData, setTeamContestData] = useState([]);
  const tenDaysBeforeDate = dayjs().subtract(7, "day").format("MM/DD/YYYY");

  const combinedArray = [...scheduleRecord, ...mappedPredictions];
  // The hook below is breaking the page because the request gives a 404 on every year...
  useEffect(() => {
    if (teamName && authToken) {
      if (year === defaultYear) {
        const res = authGetRequest(`/api/schedule/future/${leagueType}/${teamName}`, authToken)
          .then((res) => {
            setTeamPredictions(res.data);
          })
          .catch(async (err) => {
            console.error("Error getting data: ", err);
          });
      } else {
        setTeamPredictions([]);
      }

      authGetRequest(`/api/${leagueType}/${year}/${teamName}/team_contest`, authToken)
        .then((res) => {
          return res.data;
        })
        .then((res) => {
          setTeamContestData(res.data);
        })
        .catch(async (err) => {
          console.error("Error getting data: ", err);
          if (err.message.includes("401") && isPremiumPlan) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  setCookie("token_access", response.access_token);
                  setAuthToken(response.access_token);
                });
            } catch (error) {
              console.error(error);
            }
          }
        });
    }
  }, [authToken, teamName, leagueType, year]);

  useEffect(() => {
    if (teamPredictions?.data?.length > 0 && scheduleRecord?.length > 0) {
      let mappedPredictionData = teamPredictions.data
        .map((prediction) => {
          const locationType = prediction["location"] == "home" ? "Home" : "Away";

          const homeTeam = prediction["opponent"];
          // prediction['location'] == 'home' ? prediction['opponent'] : prediction['Away_Team']
          const awayTeam = prediction["opponent"];
          // prediction['Away_Team'] === teamName ? prediction['Home_Team'] : prediction['Away_Team']

          return {
            ...prediction,
            Opponent: awayTeam,
            Date: prediction["date"].split("-").reverse().join("/"),
            Result: `${prediction["projected_score"] >= prediction["projected_opp_score"] ? "W" : "L"}, ${Math.round(
              prediction["projected_score"]
            )}-${Math.round(prediction["projected_opp_score"])}`,

            // locationType === 'Home'
            //   ? `${homeTeam === prediction['Winner'] ? 'W' : 'L'}, ${
            //       prediction['Home_Team_Score']
            //     }-${prediction['Away_Team_Score']}`
            //   : `${homeTeam === prediction['Winner'] ? 'W' : 'L'}, ${
            //       prediction['Away_Team_Score']
            //     }-${prediction['Home_Team_Score']}`,
            Team: homeTeam,
            game_link: "#",
            Win_Game_Percent: `${Math.round(prediction["predicted_win_percent"])}`,
            // locationType === 'Away' && awayTeam === prediction['Winner']
            //   ? `${100 - Number.parseInt(prediction['Percent_won'])}`
            //   : homeTeam === prediction['Winner']
            //   ? `${prediction['Percent_won']}`
            //   : `${100 - Number.parseInt(prediction['Percent_won'])}`,
            Location: locationType,
            Type: "prediction",
            parsedDate: dayjs(prediction["date"])["$d"],
          };
        })
        .sort((predictionA, predictionB) => predictionA["parsedDate"].getTime() - predictionB["parsedDate"].getTime());

      const lastTeamElement = scheduleRecord[scheduleRecord.length - 1];

      if (lastTeamElement?.["Date"]) {
        const lastScheduleDate = new Date(lastTeamElement["Date"].split("/").reverse().join("/"));

        const lastTwoDays = dayjs().subtract(2, "day");

        mappedPredictionData = mappedPredictionData.filter((prediction) => {
          const predictionDate = prediction["parsedDate"];

          return (
            predictionDate.getTime() > lastScheduleDate.getTime() &&
            dayjs(predictionDate.toDateString()).isAfter(lastTwoDays, "d")
          );
        });
      }

      setMappedPredictions(mappedPredictionData);
    } else {
      setMappedPredictions([]);
    }
  }, [teamPredictions, scheduleRecord]);

  useEffect(() => {
    const { teamName } = router.query;

    setStore({ ...store, leagueType });
    setAllPlaysHeader(allPlaysHeaderList);

    if (year !== "2020") {
      setTeamSummaryHeader(teamSummaryHeader2021);
      setPlayerStatsHeader(playerStatsHeader2021);
    } else {
      setTeamSummaryHeader(teamSummaryHeader2020);
      setPlayerStatsHeader(playerStatsHeader2020);
    }
    setTeamName(teamName);

    async function load() {
      const responses = await Promise.all([
        authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/summary`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data) {
              return response.data.map((dt) => {
                return {
                  ...dt,
                  Adjusted_Shot_Quality: Number.parseFloat(
                    (dt["Offensive_Shot_Quality"] - dt["Defensive_Shot_Quality"]).toFixed(2)
                  ),
                };
              });
            }
          })
          .then((response) => {
            if (response) {
              setAvailableYearData([...availableYearData, year]);
              setTeamSummary(response);
              setTeamRecord(response[0]["Actual_Record"]);
            }
          })
          .catch(async (err) => {
            console.error("Error getting data: ", err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/important_players`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response) {
              if (response.data) {
                const filteredPoss = response.data?.filter((player) => player["Possessions"] >= 10);

                setPlayersStat(filteredPoss);
              }
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/all_plays`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data) {
              setAllPlays(response.data);
              const occurrences = response.data.map((dt) => dt["Occurrences"]);
              const players = response.data.map((dt) => dt["Player"]);

              setAllPlaysOccurrencesMinMax([Math.min(...occurrences), Math.max(...occurrences)]);

              setTeamPlayers(Array.from(new Set(players)));
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/schedule`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data) {
              const record = response.data.map((elem) => {
                let winGamePercent = Number.parseInt(elem["Win_Game_Percent"]);
                return {
                  ...elem,
                  Win_Game_Percent: winGamePercent,
                };
              });

              setScheduleRecord([...record]);

              setAllPlaysOccurrencesDefault(response.data.length / 2);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/coach`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data) {
              const index = Object.keys(response?.data)[0] ?? {};
              setCoachRecord({
                coach: response.data[index]["Coach"],
                shotQuality: response.data[index]["SQ PPP After Time Out"],
                rankOfCoach: response.data[index]["Rank"],
              });
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        leagueType !== "wnba" &&
          authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_playtypes_off`, authToken)
            .then((response) => {
              return response.data;
            })
            .then((response) => {
              if (response.data?.length > 0) {
                setConfPlayTypesOFF(response.data[0]);
              }
            })
            .catch(async (err) => {
              console.error(err);
            }),
        leagueType !== "wnba" &&
          authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_playtypes_def`, authToken)
            .then((response) => {
              return response.data;
            })
            .then((response) => {
              if (response.data?.length > 0) {
                setConfPlayTypesDEF(response.data[0]);
              }
            })
            .catch(async (err) => {
              console.error(err);
            }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/playtypes_def`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setTeamPlayTypesDEF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/playtypes_off`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setTeamPlayTypesOFF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/regression_off`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setRegressionOFF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/regression_def`, authToken)
          .then((response) => {
            if (response.status !== 200) {
              throw Error("Error Loading Regression Def Data");
            }

            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setRegressionDEF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_regression_off`, authToken)
          .then((response) => {
            if (response.status !== 200) {
              throw Error("Error Loading Regression Def Data");
            }

            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setConfRegressionOFF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_regression_def`, authToken)
          .then((response) => {
            if (response.status !== 200) {
              throw Error("Error Loading Regression Conf Def Data");
            }
            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setConfRegressionDEF(response.data[0]);
            }
          })
          .catch((err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/regression_efficiency`, authToken)
          .then((response) => {
            if (response.status !== 200) {
              throw Error("Error Loading Regression Eff Data");
            }

            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setRegressionEFF(response.data[0]);
            }
          })
          .catch((err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/misc_off`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setMiscOFF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/misc_def`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setMiscDEF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_misc_off`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setConfMiscOFF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_misc_def`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setConfMiscDEF(response.data[0]);
            }
          })
          .catch(async (err) => {
            console.error(err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/player_playtypes`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data.length > 0) {
              setPlayerPlaytypes(response.data);
            }
          })
          .catch(async (err) => {
            console.error("Error Getting Player PlayTypes Data :(", err);
          }),
        authGetRequest(`/api/${leagueType}/${year}/${teamName}/conf_player__playtypes`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response.data?.length > 0) {
              setConfPlaytypes(response.data);
            }
          })
          .catch(async (err) => {
            console.error("Error Getting Conf PlayTypes Data :(");
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  });
              } catch (error) {
                console.error(error);
              }
            }
          }),
      ]);
    }
    if (authToken) {
      load();
    }

    function CheckForTeamYear() {
      //Check Year 2020 Status:
      let alternateYear = year === "2020" ? "2021" : "2020";
      authGetRequest(`/api/${leagueType}/${alternateYear}/teams/${teamName}/schedule`, authToken)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          if (response.data) {
            setAvailableYearData([year, alternateYear]);
          }
        })
        .catch(async (err) => {
          console.error("Error Loading Alternative Year Status", err);
        });
    }

    if (authToken) {
      CheckForTeamYear();
    }

    function loadFinalTeamDescriptions() {
      authGetRequest(`/api/${leagueType}/${year}/teams/${teamName}/description`, authToken)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          if (response.data) {
            const filteredTeamDescription = response.data.filter((data) => data["Team"] === teamName);

            if (filteredTeamDescription.length > 0) {
              const desc = [];
              Object.keys(filteredTeamDescription[0]).forEach((key) => {
                if (key.includes("Type")) {
                  desc.push(filteredTeamDescription[0][key]);
                }
              });
              setTeamDescriptionRecordLength(response.data.length);
              setTeamDescriptions(desc);
            }
          }
        })
        .catch(async (err) => {
          console.error("Error Loading Defensive Data:", err);
        });
    }

    if (authToken) {
      loadFinalTeamDescriptions();
    }

    function getTeamSummaryRank() {
      const sessionTeamStats = JSON.parse(sessionStorage.getItem("TeamStandings"))?.[year];

      if (sessionTeamStats && authToken) {
        setTeamRank(() => {
          return Utils.getTeamRank(sessionTeamStats, teamName);
        });
      } else {
        authGetRequest(`/api/${leagueType}/${year}/team-standings`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            return response.data.map((dt) => {
              return {
                ...dt,
                Adjusted_Shot_Quality: Number.parseFloat(
                  (dt["Offensive_Shot_Quality"] - dt["Defensive_Shot_Quality"]).toFixed(2)
                ),
              };
            });
          })
          .then((response) => {
            if (response.length > 0) {
              setTeamRank(() => {
                return Utils.getTeamRank(response, teamName);
              });
            }
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  });
              } catch (error) {
                console.error(error);
              }
            }
            console.error("Request failed :(");
          });
      }
    }
    if (authToken) {
      getTeamSummaryRank();
    }
    function getTeamOptimizationSentences() {
      if (
        coachTeam?.length > 0 &&
        coachTeam === teamName &&
        (year === "2021" || year === "2022") &&
        leagueType !== "nba" &&
        teamName.length > 0
      ) {
        authGetRequest(`/api/${leagueType}/${year}/shot-selection-team/${teamName}`, authToken)
          .then((response) => {
            return response.data;
          })
          .then((response) => {
            if (response?.data?.length > 0) {
              const sentencesObj = response.data[0];
              const sentencesArr = Object.keys(sentencesObj)
                .map((key) => {
                  return sentencesObj[key];
                })
                .filter((elem) => elem !== null && typeof elem === "string")
                .slice(1);
              if (sentencesArr.length > 0) {
                setTeamOptimizationSentences(sentencesArr);
              }
            }
          })
          .catch(async (err) => {
            console.error(err);
          });
      }
    }
    if (authToken) {
      getTeamOptimizationSentences();
    }
  }, [authToken, year]);

  useEffect(() => {
    if (playerPlaytypes.length > 0) {
      let sortedObj = {};

      [
        ...shotTypeAnalysisCategories["playstyles"],
        ...shotTypeAnalysisCategories["playtypes"],
        ...shotTypeAnalysisCategories["shottypes"],
      ].map((category) => {
        let sortedCategory = [
          ...playerPlaytypes.sort((a, b) => {
            if (a[`${category} Occurrences`] !== null && b[`${category} Occurrences`] !== null) {
              return a[`${category} Occurrences`] - b[`${category} Occurrences`];
            } else {
              return -1;
            }
          }),
        ]
          .reverse()
          .slice(0, 3);

        sortedObj[category] = sortedCategory;
      });
      setSortedShotTypes((sortedShotTypes) => {
        return {
          ...sortedShotTypes,
          player: sortedObj,
        };
      });
    }
  }, [playerPlaytypes]);

  useEffect(() => {
    if (confPlayTypes.length > 0) {
      let sortedObj = {};
      [
        ...shotTypeAnalysisCategories["playstyles"],
        ...shotTypeAnalysisCategories["playtypes"],
        ...shotTypeAnalysisCategories["shottypes"],
      ].map((category) => {
        let sortedCategory = [
          ...confPlayTypes.sort((a, b) => {
            if (a[`${category} Occurrences`] !== null && b[`${category} Occurrences`] !== null) {
              return a[`${category} Occurrences`] - b[`${category} Occurrences`];
            } else {
              return -1;
            }
          }),
        ]
          .reverse()
          .slice(0, 3);

        sortedObj[category] = sortedCategory;

        setSortedShotTypes((sortedShotTypes) => {
          return {
            ...sortedShotTypes,
            conf: sortedObj,
          };
        });
      });
    }
  }, [confPlayTypes]);

  useEffect(() => {
    if (allPlays.length > 0) {
      setFilteredAllPlays(allPlays.sort(Utils.dynamicsort("SQ_PPP", "desc")));
    }
  }, [allPlays, setAllPlays]);

  useEffect(() => {
    setScheduleRecordLoaded(true);
  }, [scheduleRecord, setScheduleRecord]);

  useEffect(() => {
    if ([miscDEF, miscOFF].every((obj) => Object.keys(obj).length > 0)) {
      setMiscLoaded(true);
    }
  }, [miscDEF, miscOFF, confMiscOFF, confMiscDEF]);

  useEffect(() => {
    if ([regressionOFF, regressionDEF].every((obj) => Object.keys(obj).length > 0)) {
      setRegressionLoaded(true);
    }
  }, [regressionOFF, regressionDEF, confRegressionOFF, confRegressionDEF]);

  useEffect(() => {
    if ([teamPlayTypesDEF, teamPlayTypesOFF].every((obj) => Object.keys(obj).length > 0)) {
      setShotTypeLoaded(true);
    }
  }, [confPlayTypesDEF, confPlayTypesOFF, teamPlayTypesDEF, teamPlayTypesOFF]);

  useEffect(() => {
    if ([regressionLoaded, miscLoaded, shotTypeLoaded].every((table) => table === true)) {
      setAllTablesLoaded(true);
    }
  }, [regressionLoaded, miscLoaded, shotTypeLoaded, scheduleRecord, conferenceTeamCount]);

  useEffect(() => {
    if (teamSummary.length > 0 && authToken) {
      const conference = teamSummary[0]["Conference"];
      authGetRequest(`/api/${leagueType}/${year}/conferences/${conference}/standings`, authToken)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          if (response.data.length > 0) {
            setConferenceTeamCount(response.data.length);
          }
        })
        .catch((err) => {
          console.error("Unable to Load Conference Team Count :(");
        });
    }
  }, [teamSummary, year, authToken, leagueType]);

  const sort = (key, dataType) => {
    let res = [];
    let ascOrder;
    let rawData;
    let setDataFn;
    let setSortKeyFn;
    let sortedKey;
    let setAscFn;

    if (dataType === "playersStat") {
      ascOrder = ascOrderPlayersStat;
      rawData = playersStat;
      setDataFn = setPlayersStat;
      setSortKeyFn = setSortedKeyPlayersStat;
      sortedKey = sortedKeyPlayersStat;
      setAscFn = setAscPlayersStat;
    }

    if (dataType === "allPlays") {
      ascOrder = ascOrderAllPlays;
      rawData = filteredAllPlays;
      setDataFn = setFilteredAllPlays;
      setSortKeyFn = setSortedKeyAllPlays;
      sortedKey = sortedKeyAllPlays;
      setAscFn = setAscAllPlays;
    }

    if (dataType === "schedule") {
      ascOrder = ascOrderSchedule;
      rawData = scheduleRecord;
      setDataFn = setScheduleRecord;
      setSortKeyFn = setSortedKeySchedule;
      sortedKey = sortedKeySchedule;
      setAscFn = setAscSchedule;
    }

    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";
      res = rawData.sort(Utils.dynamicsort(key, order));
      setAscFn(order === "desc");
    } else {
      setAscFn(false);
      setSortKeyFn(key);
      res = rawData.sort(Utils.dynamicsort(key));
    }
    setDataFn([...res]);
  };

  const filterAllPlaysByOccurrences = (inputValue) => {
    setFilteredAllPlays([
      ...allPlays.filter((allplay) => Number.parseInt(allplay["Occurrences"]) >= Number.parseInt(inputValue)),
    ]);
  };

  return (
    <>
      <Head>
        <title>{`${defaultYear} ${team_name} Basketball Odds, Predictions & Schedule | ShotQuality Bets`}</title>
        <meta
          property="og:title"
          content={`${defaultYear} ${team_name} Basketball Odds, Predictions & Schedule | ShotQuality Bets`}
        />
        <meta property="og:description" content={`Basketball Odds, Predictions & Schedule | ShotQuality Bets`} />
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@ShotQualityBets" />
        <link rel="me" href="https://twitter.com/@ShotQualityBets"></link>

        <meta
          property="description"
          content={`View odds, predictions, picks, best bets, and lines for the ${team_name} basketball for the entire 2025-2026 season. Unlock
          the most valuable dataset in ${league?.toUpperCase()} basketball.`}
        />
        <meta
          property="og:description"
          content={`View odds, predictions, picks, best bets, and lines for the ${team_name} basketball for the entire 2025-2026 season. Unlock
          the most valuable dataset in ${league?.toUpperCase()} basketball.`}
        />
      </Head>
      <MainLayout>
        <main id="ContentBox" className="Titleside" style={{ paddingTop: 0 }}>
          {/* Start Title side */}
          <div className="Titleside teamHeader text-center team">
            {teamName ? (
              <div className="container">
                <div className="d-md-flex align-items-center justify-content-center pt-2 pb-2">
                  <img src={`/static/media/logos/${teamName}.png`} alt={teamName} className="teamLogo" />
                  <div className="d-block d-md-inline-block">
                    <p>
                      {year} Scoring report for {teamName}
                    </p>
                    {teamRecord.length > 0 && teamRecord ? (
                      <>
                        <h2>
                          {teamName} <span>({teamRecord})</span>
                        </h2>

                        {/* <p style={{ marginBottom: "40px" }}>
                      {leagueType !== "wnba" && (
                        <>
                          Head coach: <b className="name">{coachRecord.coach}</b>
                        </>
                      )}
                    </p> */}
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : (
              <LoadingSkeleton variant="header" height="100px" width="50%" />
            )}
          </div>
          <div style={{ clear: "both" }}></div>
          <div style={{ position: "relative" }}>
            <section style={{ backgroundColor: "#F2F4F6", paddingBottom: "28px" }}>
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-sm-12">
                    <div className="Titleside pl-3">
                      <div className="box">
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center">
                            <div className="paginationLinkGroup d-inline-flex">
                              {yearArray.map((yr) => (
                                <div
                                  key={yr + "team"}
                                  onClick={() => setYear(yr)}
                                  // href={`/team/${league}/${year}/${teamName}`}
                                  className={`paginationLink ${yr === year ? "active" : ""}`}
                                >
                                  {yr}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <h2 className="text-center" style={{ margin: "40px 0 6px 0" }}>
                          {year}{" "}
                          {leagueType === "nba"
                            ? " NBA Men's"
                            : leagueType === "wnba"
                            ? " WNBA"
                            : leagueType === "college_womens"
                            ? "NCAA Women's"
                            : " NCAA Men's"}{" "}
                          Basketball Team Ranking
                        </h2>
                        <p className="text-center">
                          {teamName} ranking in {year} in each ShotQuality basketball statistic
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {teamDescriptions.length > 0 && user ? (
                  <List itemCount={5} isLoading={false} classNames="rankList">
                    {teamDescriptions.map((desc, i) => {
                      const rank = desc.match(/\(([^\)]+)\)+$/g) ?? [];
                      const rankNum = rank.length > 0 ? rank[0].split(":")[1].replace(")", "").trim() : "";
                      const textColor =
                        desc.includes("Tempo") ||
                        desc.toLowerCase().includes("frequency") ||
                        desc.toLowerCase().includes("lots of 3pt attempts allowed on defense") ||
                        desc.toLowerCase().includes("shots attacking rim allowed on defense")
                          ? "rgb(235, 171, 52)"
                          : Number.parseInt(rankNum) > teamDescriptionRecordLength * 0.66
                          ? "red"
                          : Number.parseInt(rankNum) < teamDescriptionRecordLength * 0.33
                          ? "green"
                          : null;

                      return (
                        <li
                          style={{
                            animation: "fade-in .5s ease-in-out forwards",
                            animationDelay: `${i * 0.075}s`,
                            justifyContent: "center",
                          }}
                          className="pl-3 pr-3 rankElement"
                          key={`sentences${i + 1}`}
                        >
                          <span className="rank" style={{ color: textColor }}>
                            {rankNum.replace(/[^0-9]/g, "")}
                            <sup>{rankNum.replace(/[^A-Za-z]/gi, "")}</sup>
                          </span>
                          <p
                            style={{
                              color: textColor,
                              width: "385px",
                              fontWeight: 700,
                              fontSize: "24px",
                              margin: 0,
                              marginLeft: "10px",
                            }}
                          >
                            {desc.replace(/\(([^\)]+)\)+$/g, "")}
                          </p>
                        </li>
                      );
                    })}
                  </List>
                ) : null}
              </div>
            </section>

            {/* Final Team Description Ends */}

            <section>
              <div className="container">
                {teamPlayers.length > 0 && teamOptimizationSenteces.length > 0 ? (
                  <Slider {...sqDocSliderSettings} ref={sliderRef}>
                    {teamOptimizationSenteces.map((sentence, i) => (
                      <div key={`sqdocteam${i + 1}`} className="p-2">
                        <SQDocCard
                          sentence={sentence}
                          teamPlayers={teamPlayers}
                          displayType="Team"
                          teamName={teamName}
                        />
                      </div>
                    ))}
                  </Slider>
                ) : null}
              </div>
            </section>

            {/* End Title side */}
            {/* Start History side */}
            <div className="Yearside text-center" style={{ paddingTop: "175px" }}>
              <div className="container w-100">
                <div className="row">
                  <div className="col-12 d-flex">
                    <div className="paginationLinkGroup d-inline-flex">
                      {yearArray.map((yr) => (
                        <div
                          key={yr + "league"}
                          onClick={() => setYear(yr)}
                          // href={`/team/${league}/${year}/${teamName}`}
                          className={`paginationLink ${yr === year ? "active" : ""}`}
                        >
                          {yr}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End History side */}

            {/* Start Score side */}
            <div className="Scoreside text-center">
              <div className="container-fluid">
                <div className="">
                  {teamSummary.length > 0 ? (
                    <div className="table-responsive summary p-2 table-space">
                      <table className="table">
                        <thead>
                          <tr>
                            <TableHeader headers={teamSummaryHeader} />
                          </tr>
                        </thead>
                        <tbody>
                          {teamSummary.map((data, i) => (
                            <tr key={`teamSummary${i + 1}`}>
                              {teamRank && (
                                <>
                                  <TableCellAdjSQ
                                    data={data[teamSummaryHeader[0].key]}
                                    rank={teamRank["adjSQRank"]}
                                    cellType="adjSQ"
                                    leagueType={leagueType}
                                    // style={{ width: "6rem" }}
                                  />
                                  <TableCellRank rankValue={teamRank["offensiveRank"]} leagueType={leagueType}>
                                    {data[teamSummaryHeader[1].key]}
                                  </TableCellRank>
                                  <TableCellRank rankValue={teamRank["defensiveRank"]} leagueType={leagueType}>
                                    {data[teamSummaryHeader[2].key]}
                                  </TableCellRank>
                                </>
                              )}

                              <td>
                                {year !== "2020"
                                  ? Utils.toPercent(data[teamSummaryHeader[3].key])
                                  : data[teamSummaryHeader[3].key]}
                              </td>
                              <td>{data[teamSummaryHeader[4].key]}</td>
                              <td style={{ minWidth: "125px" }}>{data[teamSummaryHeader[5].key]}</td>
                              <td>{Utils.toPercent(data[teamSummaryHeader[6].key])}</td>
                              <td>
                                {year !== "2020"
                                  ? Utils.toPercent(data[teamSummaryHeader[7].key])
                                  : data[teamSummaryHeader[7].key]}
                              </td>
                              {/* {year !== '2020' && <td>{data[teamSummaryHeader[9].key]}</td>} */}
                              {year !== "2020" && (
                                <td
                                  style={{
                                    color: data[teamSummaryHeader[8]?.key] > 0 ? "#208502" : "#D82011",
                                    fontWeight: 700,
                                    // textAlign: "right",
                                    paddingRight: "20px",
                                  }}
                                >
                                  {data[teamSummaryHeader[8]?.key] > 0 && "+"}
                                  {data[teamSummaryHeader[8]?.key]?.toFixed(2)}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <TableSkeleton tableRowsCount={1} tableHeader={teamSummaryHeader} />
                  )}
                </div>
                {/* <div className="dukescroe"> */}
                <div className="p-2">
                  <div className="row row-eq-height">
                    <div className={`col-sm-12 col-lg-6`}>
                      {/* <div className="col-lg-6"> */}
                      <div className="box mb-3">
                        <h4 style={{ fontSize: 24 }}>{year} Schedule</h4>
                        <div className="table-responsive team-schedule">
                          <div
                            className="paginationLinkGroup d-flex"
                            style={{
                              margin: "32px 0",
                              paddingLeft: "16px",
                            }}
                          >
                            <button
                              type="button"
                              className={`paginationLink ${scheduleFilter === "All" ? "active" : ""}`}
                              onClick={() => setScheduleFilter("All")}
                              value="All"
                            >
                              All
                            </button>
                            <button
                              type="button"
                              className={`paginationLink win ${scheduleFilter === "Win" ? "active" : ""}`}
                              onClick={() => setScheduleFilter("Win")}
                              value="Win"
                            >
                              Win
                            </button>
                            <button
                              type="button"
                              className={`paginationLink loss ${scheduleFilter === "Loss" ? "active" : ""}`}
                              onClick={() => setScheduleFilter("Loss")}
                              value="Loss"
                            >
                              Loss
                            </button>
                            <button
                              type="button"
                              className={`paginationLink unexpected ${scheduleFilter === "Unexpected" ? "active" : ""}`}
                              onClick={() => setScheduleFilter("Unexpected")}
                              value="Unexpected"
                            >
                              Unexpected
                            </button>
                          </div>
                          <table className="table teamSchedule">
                            <thead className="sticky-th-2">
                              <tr>
                                <TableHeader
                                  headers={
                                    (year === defaultYear &&
                                      (leagueName === "nba" ||
                                        leagueName === "wnba" ||
                                        leagueName === "ncaa" ||
                                        leagueName === "college_mens")) ||
                                    isTraderPlan
                                      ? scheduleRecordHeader
                                      : year !== defaultYear
                                      ? scheduleRecordHeader.filter(
                                          (item) =>
                                            item.key !== "SQ_Result" &&
                                            item.key !== "current_spread" &&
                                            item.key !== "current_total"
                                        )
                                      : scheduleRecordHeader.filter((item) => item.key !== "SQ_Result")
                                  }
                                  sortedKey={sortedKeySchedule}
                                  onSortClick={(key) => sort(key, "schedule")}
                                  ascOrder={ascOrderSchedule}
                                />
                              </tr>
                            </thead>
                            <tbody>
                              {combinedArray.map((data, i) => {
                                const dateString =
                                  data?.["Type"] !== "prediction"
                                    ? new Date(data[scheduleRecordHeader[0].key]?.split("/").reverse().join("/"))
                                    : data["parsedDate"];

                                const formattedDate = dayjs(dateString).format("MM/DD/YYYY");
                                const isDateBefore = dayjs(formattedDate, "MM/DD/YYYY").isBefore(
                                  dayjs(tenDaysBeforeDate, "MM/DD/YYYY")
                                );

                                const RL =
                                  data?.["Type"] !== "prediction"
                                    ? data[scheduleRecordHeader[2].key].includes("L")
                                    : "";
                                const RW =
                                  data?.["Type"] !== "prediction"
                                    ? data[scheduleRecordHeader[2].key].includes("W")
                                    : "";
                                const SRL =
                                  data?.["Type"] !== "prediction"
                                    ? data[scheduleRecordHeader[3].key].includes("L")
                                    : "";
                                const SRW =
                                  data?.["Type"] !== "prediction"
                                    ? data[scheduleRecordHeader[3].key].includes("W")
                                    : "";

                                const win = RW && SRW;
                                const loss = RL && SRL;
                                const unexpected = !win && !loss;
                                const rowColor = win ? "#AEF2B9" : loss ? "#F6C2B4" : "#FEFF7F";
                                // const gameLink =
                                //   data["game_link"] !== "#" && data["game_link"] && isPremiumPlan && year === defaultYear
                                //     ? `/game/${leagueName}/${year}/${teamName}/${data["game_link"]}`
                                //     : "";
                                const gameLink =
                                  data["game_link"] !== "#" &&
                                  data["game_link"] &&
                                  (year === defaultYear || isTraderPlan)
                                    ? `/game/${leagueName}/${year}/${teamName}/${data["game_link"]}`
                                    : "";
                                const homeTeam = data.location === "home" ? data.team : data.opponent;
                                const awayTeam = homeTeam === data.team ? data.opponent : data.team;
                                const matchupLink =
                                  (isPremiumPlan && year === defaultYear) || isTraderPlan
                                    ? `/${leagueName}/matchup-output/${homeTeam}/${awayTeam}/${data.date}`
                                    : "";

                                let totalResult = null;
                                totalResult = data["Result"]
                                  .split(" ")[1]
                                  .split("-")
                                  .reduce((a, b) => Number(a) + Number(b), 0);

                                totalResult = data?.current_total ? `(${totalResult})` : "";

                                const spreadCovered = data?.away_score - data?.home_score - data?.current_spread;
                                let spreadColor = "";
                                if (data.Team === data?.home) {
                                  spreadColor = spreadCovered < 0 ? "green" : spreadCovered === 0 ? "#c5c50b" : "red";
                                } else if (data.Team === data?.away) {
                                  spreadColor = spreadCovered > 0 ? "green" : spreadCovered === 0 ? "#c5c50b" : "red";
                                }

                                if (scheduleFilter === "Win" && win) {
                                  return (
                                    <Fragment key={uuidv4()}>
                                      {leagueType !== "nba" || i < 25 || loadMoreSchedule ? (
                                        <tr
                                          style={{
                                            backgroundColor: data?.["Type"] !== "prediction" ? rowColor : "",
                                          }}
                                          key={"schedule" + i}
                                        >
                                          {data?.["Type"] !== "prediction" ? (
                                            <Fragment>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  `${
                                                    dateString.getMonth() + 1
                                                  }/${dateString.getDate()}/${dateString.getFullYear()}`
                                                )}
                                              </td>
                                              <td>
                                                {data[scheduleRecordHeader[1].key] == "Division 2/3 team" ? (
                                                  data[scheduleRecordHeader[1].key]
                                                ) : (
                                                  <a
                                                    href={`/team/${leagueName}/${year}/${
                                                      data[scheduleRecordHeader[1].key]
                                                    }`}
                                                  >
                                                    {data[scheduleRecordHeader[1].key]}
                                                  </a>
                                                )}
                                              </td>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[2].key]}</>
                                                )}
                                              </td>
                                              {((year === defaultYear &&
                                                // leagueName !== "ncaa" &&
                                                // leagueName !== "college_mens" &&
                                                leagueName !== "ncaaw" &&
                                                leagueName !== "college_womens") ||
                                                isTraderPlan) && (
                                                <>
                                                  {isDateBefore && isStandardPlan ? (
                                                    <td>
                                                      <CustomLock />
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {gameLink ? (
                                                        <Link href={gameLink}>{data[scheduleRecordHeader[3].key]}</Link>
                                                      ) : (
                                                        <>{data[scheduleRecordHeader[3].key]}</>
                                                      )}
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{`${data[scheduleRecordHeader[4].key]}%`}</Link>
                                                ) : (
                                                  <>{`${data[scheduleRecordHeader[4].key]}%`}</>
                                                )}
                                              </td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {gameLink ? (
                                                      <Link style={{ color: spreadColor }} href={gameLink}>
                                                        {data[scheduleRecordHeader[5].key]}
                                                      </Link>
                                                    ) : (
                                                      <>{data[scheduleRecordHeader[5].key]}</>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {gameLink ? (
                                                      <Link href={gameLink}>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </Link>
                                                    ) : (
                                                      <>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[7].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[7].key]}</>
                                                )}
                                              </td>
                                            </Fragment>
                                          ) : (
                                            <Fragment>
                                              <td>
                                                {`${
                                                  dateString.getMonth() + 1
                                                }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                              </td>
                                              <td>
                                                <a
                                                  href={`/team/${leagueName}/${year}/${
                                                    data[scheduleRecordHeader[1].key]
                                                  }`}
                                                >
                                                  {data[scheduleRecordHeader[1].key]}
                                                </a>
                                              </td>
                                              <td>{data[scheduleRecordHeader[2].key]}</td>
                                              <td></td>
                                              <td>{data[scheduleRecordHeader[4].key]}%</td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {data[scheduleRecordHeader[5].key]}
                                                  </td>
                                                  <td>
                                                    {data[scheduleRecordHeader[6].key]} {totalResult}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>{data[scheduleRecordHeader[7].key]}</td>
                                            </Fragment>
                                          )}
                                        </tr>
                                      ) : null}
                                    </Fragment>
                                  );
                                } else if (scheduleFilter === "Loss" && loss) {
                                  return (
                                    <Fragment key={uuidv4()}>
                                      {leagueType !== "nba" || i < 25 || loadMoreSchedule ? (
                                        <tr
                                          style={{
                                            backgroundColor: data?.["Type"] !== "prediction" ? rowColor : "",
                                          }}
                                          key={"schedule" + i}
                                        >
                                          {data?.["Type"] !== "prediction" ? (
                                            <Fragment>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>
                                                    {" "}
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  <>
                                                    {" "}
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </>
                                                )}
                                              </td>
                                              <td>
                                                {data[scheduleRecordHeader[1].key] == "Division 2/3 team" ? (
                                                  data[scheduleRecordHeader[1].key]
                                                ) : (
                                                  <a
                                                    href={`/team/${leagueName}/${year}/${
                                                      data[scheduleRecordHeader[1].key]
                                                    }`}
                                                  >
                                                    {data[scheduleRecordHeader[1].key]}
                                                  </a>
                                                )}
                                              </td>
                                              <TiDevicePhone>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[2].key]}</>
                                                )}
                                              </TiDevicePhone>
                                              {((year === defaultYear &&
                                                // leagueName !== "ncaa" &&
                                                // leagueName !== "college_mens" &&
                                                leagueName !== "ncaaw" &&
                                                leagueName !== "college_womens") ||
                                                isTraderPlan) && (
                                                <>
                                                  {isDateBefore && isStandardPlan ? (
                                                    <td>
                                                      <CustomLock />
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {gameLink ? (
                                                        <Link href={gameLink}>{data[scheduleRecordHeader[3].key]}</Link>
                                                      ) : (
                                                        <>{data[scheduleRecordHeader[3].key]}</>
                                                      )}
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{`${data[scheduleRecordHeader[4].key]}%`}</Link>
                                                ) : (
                                                  <>{`${data[scheduleRecordHeader[4].key]}%`}</>
                                                )}
                                              </td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {gameLink ? (
                                                      <Link style={{ color: spreadColor }} href={gameLink}>
                                                        {data[scheduleRecordHeader[5].key]}
                                                      </Link>
                                                    ) : (
                                                      <>{data[scheduleRecordHeader[5].key]}</>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {gameLink ? (
                                                      <Link href={gameLink}>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </Link>
                                                    ) : (
                                                      <>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[7].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[7].key]}</>
                                                )}
                                              </td>
                                            </Fragment>
                                          ) : (
                                            <Fragment>
                                              <td>
                                                {`${
                                                  dateString.getMonth() + 1
                                                }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                              </td>
                                              <td>
                                                <a
                                                  href={`/team/${leagueName}/${year}/${
                                                    data[scheduleRecordHeader[1].key]
                                                  }`}
                                                >
                                                  {data[scheduleRecordHeader[1].key]}
                                                </a>
                                              </td>
                                              <td>{data[scheduleRecordHeader[2].key]}</td>
                                              <td></td>
                                              <td>{data[scheduleRecordHeader[4].key]}%</td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {data[scheduleRecordHeader[5].key]}
                                                  </td>
                                                  <td>
                                                    {data[scheduleRecordHeader[6].key]} {totalResult}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>{data[scheduleRecordHeader[7].key]}</td>
                                            </Fragment>
                                          )}
                                        </tr>
                                      ) : null}
                                    </Fragment>
                                  );
                                } else if (scheduleFilter === "Unexpected" && unexpected) {
                                  return (
                                    <Fragment key={uuidv4()}>
                                      {leagueType !== "nba" || i < 25 || loadMoreSchedule ? (
                                        <tr
                                          style={{
                                            backgroundColor: data?.["Type"] !== "prediction" ? rowColor : "",
                                          }}
                                          key={"schedule" + i}
                                        >
                                          {data?.["Type"] !== "prediction" ? (
                                            <Fragment>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  <>{`${
                                                    dateString.getMonth() + 1
                                                  }/${dateString.getDate()}/${dateString.getFullYear()}`}</>
                                                )}
                                              </td>
                                              <td>
                                                {data[scheduleRecordHeader[1].key] == "Division 2/3 team" ? (
                                                  data[scheduleRecordHeader[1].key]
                                                ) : (
                                                  <a
                                                    href={`/team/${leagueName}/${year}/${
                                                      data[scheduleRecordHeader[1].key]
                                                    }`}
                                                  >
                                                    {data[scheduleRecordHeader[1].key]}
                                                  </a>
                                                )}
                                              </td>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[2].key]}</>
                                                )}
                                              </td>
                                              {((year === defaultYear &&
                                                // leagueName !== "ncaa" &&
                                                // leagueName !== "college_mens" &&
                                                leagueName !== "ncaaw" &&
                                                leagueName !== "college_womens") ||
                                                isTraderPlan) && (
                                                <>
                                                  {isDateBefore && isStandardPlan ? (
                                                    <td>
                                                      <CustomLock />
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {gameLink ? (
                                                        <Link href={gameLink}>{data[scheduleRecordHeader[3].key]}</Link>
                                                      ) : (
                                                        <>{data[scheduleRecordHeader[3].key]}</>
                                                      )}
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{`${data[scheduleRecordHeader[4].key]}%`}</Link>
                                                ) : (
                                                  <>{`${data[scheduleRecordHeader[4].key]}%`}</>
                                                )}
                                              </td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {gameLink ? (
                                                      <Link style={{ color: spreadColor }} href={gameLink}>
                                                        {data[scheduleRecordHeader[5].key]}
                                                      </Link>
                                                    ) : (
                                                      <>{data[scheduleRecordHeader[5].key]}</>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {gameLink ? (
                                                      <Link href={gameLink}>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </Link>
                                                    ) : (
                                                      <>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[7].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[7].key]}</>
                                                )}
                                              </td>
                                            </Fragment>
                                          ) : (
                                            <Fragment>
                                              <td>
                                                {matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  `${
                                                    dateString.getMonth() + 1
                                                  }/${dateString.getDate()}/${dateString.getFullYear()}`
                                                )}
                                              </td>
                                              <td>
                                                <a
                                                  href={`/team/${leagueName}/${year}/${
                                                    data[scheduleRecordHeader[1].key]
                                                  }`}
                                                >
                                                  {data[scheduleRecordHeader[1].key]}
                                                </a>
                                              </td>
                                              <td>
                                                {matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  data[scheduleRecordHeader[2].key]
                                                )}
                                              </td>
                                              <td></td>
                                              <td>{data[scheduleRecordHeader[4].key]}%</td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {data[scheduleRecordHeader[5].key]}
                                                  </td>
                                                  <td>
                                                    {data[scheduleRecordHeader[6].key]} {totalResult}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>{data[scheduleRecordHeader[7].key]}</td>
                                            </Fragment>
                                          )}
                                        </tr>
                                      ) : null}
                                    </Fragment>
                                  );
                                } else if (scheduleFilter === "All") {
                                  return (
                                    <Fragment key={uuidv4()}>
                                      {leagueType !== "nba" || i < 25 || loadMoreSchedule ? (
                                        <tr
                                          style={{
                                            backgroundColor: data?.["Type"] !== "prediction" ? rowColor : "",
                                          }}
                                          key={"schedule" + i}
                                        >
                                          {data?.["Type"] !== "prediction" ? (
                                            <Fragment>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  <>{`${
                                                    dateString.getMonth() + 1
                                                  }/${dateString.getDate()}/${dateString.getFullYear()}`}</>
                                                )}
                                              </td>
                                              <td>
                                                {data[scheduleRecordHeader[1].key] == "Division 2/3 team" ? (
                                                  data[scheduleRecordHeader[1].key]
                                                ) : (
                                                  <a
                                                    href={`/team/${leagueName}/${year}/${
                                                      data[scheduleRecordHeader[1].key]
                                                    }`}
                                                  >
                                                    {data[scheduleRecordHeader[1].key]}
                                                  </a>
                                                )}
                                              </td>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[2].key]}</>
                                                )}
                                              </td>
                                              {((year === defaultYear &&
                                                // leagueName !== "ncaa" &&
                                                // leagueName !== "college_mens" &&
                                                leagueName !== "ncaaw" &&
                                                leagueName !== "college_womens") ||
                                                isTraderPlan) && (
                                                <>
                                                  {isDateBefore && isStandardPlan ? (
                                                    <td>
                                                      <CustomLock />
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      {gameLink ? (
                                                        <Link href={gameLink}>{data[scheduleRecordHeader[3].key]}</Link>
                                                      ) : (
                                                        <>{data[scheduleRecordHeader[3].key]}</>
                                                      )}
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{`${data[scheduleRecordHeader[4].key]}%`}</Link>
                                                ) : (
                                                  <>{`${data[scheduleRecordHeader[4].key]}%`}</>
                                                )}
                                              </td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {gameLink ? (
                                                      <Link style={{ color: spreadColor }} href={gameLink}>
                                                        {data[scheduleRecordHeader[5].key]}
                                                      </Link>
                                                    ) : (
                                                      <>{data[scheduleRecordHeader[5].key]}</>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {gameLink ? (
                                                      <Link href={gameLink}>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </Link>
                                                    ) : (
                                                      <>
                                                        {data[scheduleRecordHeader[6].key]} {totalResult}
                                                      </>
                                                    )}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>{data[scheduleRecordHeader[7].key]}</Link>
                                                ) : (
                                                  <>{data[scheduleRecordHeader[7].key]}</>
                                                )}
                                              </td>
                                            </Fragment>
                                          ) : (
                                            <Fragment>
                                              <td>
                                                {gameLink ? (
                                                  <Link href={gameLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : matchupLink ? (
                                                  <Link href={matchupLink}>
                                                    {`${
                                                      dateString.getMonth() + 1
                                                    }/${dateString.getDate()}/${dateString.getFullYear()}`}
                                                  </Link>
                                                ) : (
                                                  <>{`${
                                                    dateString.getMonth() + 1
                                                  }/${dateString.getDate()}/${dateString.getFullYear()}`}</>
                                                )}
                                              </td>
                                              <td>
                                                <a
                                                  href={`/team/${leagueName}/${year}/${
                                                    data[scheduleRecordHeader[1].key]
                                                  }`}
                                                >
                                                  {data[scheduleRecordHeader[1].key]}
                                                </a>
                                              </td>
                                              <td>
                                                {matchupLink ? (
                                                  <Link href={matchupLink}>{data[scheduleRecordHeader[2].key]}</Link>
                                                ) : (
                                                  data[scheduleRecordHeader[2].key]
                                                )}
                                              </td>
                                              {((year === defaultYear &&
                                                // leagueName !== "ncaa" &&
                                                // leagueName !== "college_mens" &&
                                                leagueName !== "ncaaw" &&
                                                leagueName !== "college_womens") ||
                                                isTraderPlan) && <td>{/* {data[scheduleRecordHeader[3].key]} */}</td>}
                                              <td>{data[scheduleRecordHeader[4].key]}%</td>
                                              {year === defaultYear || isTraderPlan ? (
                                                <>
                                                  <td style={{ color: spreadColor }}>
                                                    {data[scheduleRecordHeader[5].key]}
                                                  </td>
                                                  <td>
                                                    {data[scheduleRecordHeader[6].key]} {totalResult}
                                                  </td>
                                                </>
                                              ) : null}
                                              <td>{data[scheduleRecordHeader[7].key]}</td>
                                            </Fragment>
                                          )}
                                        </tr>
                                      ) : null}
                                    </Fragment>
                                  );
                                }
                              })}
                            </tbody>
                          </table>
                          {!loadMoreSchedule && leagueType === "nba" && scheduleRecord.length > 30 && (
                            <div className="btnShowMore mt-4">
                              <a onClick={() => setLoadMoreSchedule(true)} className="btn btn-primary Home2">
                                Show More
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`col-sm-12 col-lg-6`}>
                      {scheduleRecordLoaded && !!allTablesLoaded ? (
                        <div className="row">
                          <div className="col-12 mb-3">
                            <TeamShotTypeAnalysis
                              {...{
                                sortedShotTypes,
                                confPlayTypesDEF,
                                confPlayTypesOFF,
                                teamPlayTypesDEF,
                                teamPlayTypesOFF,
                                leagueType,
                                year,
                                conferenceTeamCount,
                                loading: false,
                              }}
                            />
                          </div>
                          <div className="col-12 mb-3">
                            <TeamRegressionAnalysis
                              {...{
                                regressionDEF,
                                regressionOFF,
                                regressionEFF,
                                confRegressionDEF,
                                confRegressionOFF,
                                leagueType,
                                year,
                                conferenceTeamCount,
                              }}
                            />
                          </div>
                          {teamContestData.length > 0 && leagueType !== "ncaaw" && leagueType !== "college_womens" && (
                            <div className="col-12 mb-3">
                              <TeamContestData data={teamContestData[0]} leagueType={leagueType} />
                            </div>
                          )}
                          <div className="col-12">
                            <TeamMiscAnalysis
                              {...{
                                miscDEF,
                                miscOFF,
                                confMiscDEF,
                                confMiscOFF,
                                leagueType,
                                year,
                                conferenceTeamCount,
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <br />
                {
                  // <div className='dukescroe AllPlaysSection'>
                  //   <div className='row'>
                  //     <div className='col-xs-12 col-sm-6 col-md-8'>
                  //       <h2 className='text-left'>{teamName} All Shot-types</h2>
                  //     </div>
                  //     <div className='col-xs-12 col-sm-6 col-md-4 text-left'>
                  //       {filteredAllPlays.length > 0 && allPlaysOccurrencesDefault > 0 ? (
                  //         <SliderRange
                  //           title='Filter By Occurences'
                  //           min={0}
                  //           max={allPlaysOccurrencesMinMax[1]}
                  //           default={allPlaysOccurrencesDefault}
                  //           filter={filterAllPlaysByOccurrences}
                  //         />
                  //       ) : null}
                  //     </div>
                  //   </div>
                  //
                  //   <div className='table-responsive pt-3 pb-3 Allplays  p-0 ptY-0'>
                  //     {filteredAllPlays.length > 0 ? (
                  //       <table className='table allShotTypes'>
                  //         <thead>
                  //           <tr>
                  //             {filteredAllPlays.length > 0 ? (
                  //               <TableHeader
                  //                 headers={allPlaysHeader}
                  //                 sortedKey={sortedKeyAllPlays}
                  //                 onSortClick={(key) => sort(key, 'allPlays')}
                  //                 ascOrder={ascOrderAllPlays}
                  //               />
                  //             ) : (
                  //               true
                  //             )}
                  //           </tr>
                  //         </thead>
                  //         <tbody>
                  //           {filteredAllPlays.map((data, i) => {
                  //             return (
                  //               <tr key={'allPlays' + i}>
                  //                 <td className='text-left'>
                  //                   <Link
                  //                     href={`/individual-player/${leagueType}/${year}/${teamName}/${data['Player']}`}
                  //                     style={{ display: 'inline-block' }}
                  //                   >{`${data['Player']} `}</Link>
                  //                   <span> {data[allPlaysHeader[0].key]}</span>
                  //                 </td>
                  //                 <td>{data[allPlaysHeader[1].key]}</td>
                  //                 <td>{data[allPlaysHeader[2].key]}</td>
                  //                 <TableCellPercentile
                  //                   value={Number.parseInt(data[allPlaysHeader[3].key]) / 100}
                  //                 />
                  //               </tr>
                  //             )
                  //           })}
                  //         </tbody>
                  //       </table>
                  //     ) : (
                  //       <TableSkeleton tableHeader={allPlaysHeader} tableRowsCount={15} />
                  //     )}
                  //   </div>
                  // </div>
                }
                {
                  // <div className='dukescroe'>
                  //   <h2 className='text-left'>Players Stats</h2>
                  //   {playersStat.length > 0 ? (
                  //     <div className='table-responsive table-space' style={{ overflow: 'auto' }}>
                  //       <table className='table playerStats'>
                  //         <thead className='sticky-th-2'>
                  //           <tr>
                  //             <TableHeader
                  //               headers={playerStatsHeader}
                  //               sortedKey={sortedKeyPlayersStat}
                  //               onSortClick={(key) => sort(key, 'playersStat')}
                  //               ascOrder={ascOrderPlayersStat}
                  //             />
                  //           </tr>
                  //         </thead>
                  //         <tbody>
                  //           {playersStat.map((data, i) => {
                  //             return (
                  //               <tr key={'dataplayer' + i}>
                  //                 <td>
                  //                   <Link
                  //                     href={`/individual-player/${leagueType}/${year}/${teamName}/${
                  //                       data[playerStatsHeader[0].key]
                  //                     }`}
                  //                   >
                  //                     {data[playerStatsHeader[0].key]}
                  //                   </Link>
                  //                 </td>
                  //                 <td>{data[playerStatsHeader[1].key]}</td>
                  //                 <td>{data[playerStatsHeader[2].key]}</td>
                  //                 <TableCellPercentile value={data[playerStatsHeader[3].key]} />
                  //                 {/* <TablePercentileGradient
                  //                   rankValue={Number.parseInt(data[playerStatsHeader[3].key])}
                  //                   totalCount={100}
                  //                 >
                  //                   {data[playerStatsHeader[3].key]}
                  //                 </TablePercentileGradient> */}
                  //                 <td>{Utils.toPercent(data[playerStatsHeader[4].key])}</td>
                  //                 <td>{Utils.toPercent(data[playerStatsHeader[5].key])}</td>
                  //                 {year !== '2020' ? (
                  //                   <td>{Utils.toPercent(data[playerStatsHeader[6].key])}</td>
                  //                 ) : (
                  //                   <td>{data[playerStatsHeader[5].key]}</td>
                  //                 )}
                  //                 <td>{data[playerStatsHeader[7].key]}</td>
                  //                 <td>{data[playerStatsHeader[8].key]}</td>
                  //                 {year !== '2020' ? <td>{data[playerStatsHeader[9].key]}</td> : null}
                  //               </tr>
                  //             )
                  //           })}
                  //         </tbody>
                  //       </table>
                  //     </div>
                  //   ) : (
                  //     <TableSkeleton tableHeader={playerStatsHeader} tableRowsCount={15} />
                  //   )}
                  // </div>
                  //
                }
              </div>
            </div>

            {!user && (
              <div
                style={{
                  top: "0%",
                  bottom: "auto",
                  height: "100%",
                  position: "absolute",
                  background: "linear-gradient(180deg,rgba(2,0,36,0),#fff 100%)",
                  backdropFilter: "blur(16px)",
                  left: 0,
                  right: 0,
                  zIndex: 50,
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "100px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    flexDirection: "column",
                    paddingTop: "5rem",
                  }}
                >
                  <h3>Sign in to See More</h3>
                  <div style={{ width: "40%", color: "#6B6C72" }}>
                    The Shot Quality Betting Model is a proven betting system. Using advanced predictive data, it
                    returned a 53.5% win rate and $6200 to a $100 bettor last season.
                  </div>
                  <Link href={"/login"}>
                    <button className="btn btn-dummy btn-lg min-width-236px">Sign in</button>
                  </Link>
                  <div
                    style={{
                      display: "flex",
                      fontSize: 18,
                      fontWeight: 600,
                      flexDirection: "row",
                      marginTop: 40,
                    }}
                  >
                    <div
                      style={{
                        color: "#0F131B",
                        fontSize: 18,
                        fontWeight: 600,
                        flexDirection: "row",
                      }}
                    >
                      Already have an account?
                    </div>
                    <Link href={"/login#login"} onClick={Utils.setPreLoginUrl}>
                      <div
                        style={{
                          color: "#F26B0B",
                          marginLeft: 10,
                          textDecoration: "underline",
                        }}
                      >
                        Sign In
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            )}
            {user && !user.has_paid && (
              <div
                style={{
                  top: "0%",
                  bottom: "auto",
                  height: "100%",
                  position: "absolute",
                  background: "linear-gradient(180deg,rgba(2,0,36,0),#fff 100%)",
                  backdropFilter: "blur(16px)",
                  left: 0,
                  right: 0,
                  zIndex: 50,
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "100px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    flexDirection: "column",
                    paddingTop: "5rem",
                  }}
                >
                  <h3>Team pages are available to Premium members</h3>
                  <div style={{ width: "40%", color: "#6B6C72" }}>
                    The Shot Quality Betting Model is a proven betting system. Using advanced predictive data, it
                    returned a 53.5% win rate and $6200 to a $100 bettor last season.
                  </div>
                  <p style={{ width: "40%" }}>{SIGNUPS_CLOSED_MESSAGE}</p>
                </div>
              </div>
            )}
          </div>
          <WinningMetrics targetPage={"TeamPage"} />
        </main>
      </MainLayout>
    </>
  );
};
export default Team;
